module.exports = __webpack_public_path__ + "static/img/soccer.4d49ced0.svg";